import { render, staticRenderFns } from "./ListHeader.vue?vue&type=template&id=61913148"
import script from "./ListHeader.vue?vue&type=script&lang=js"
export * from "./ListHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports